<template>
  <div class="dea-light-tabs">
    <div class="xs-12 dea-light-tabs__header dea-tabs__header">
      <slot name="header" :openTab="{ openTab }"></slot>
    </div>
    <div class="xs-12 dea-tabs-contents">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
/**
 * **Include incompatible changes**
 */

import tabs from "../mixins/tabs";

export default {
  name: "LightTabContainer",
  mixins: [tabs],
};
</script>
